import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper } from "../Styles/PageStyles";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import moment from "moment";
import Config, { PaginationLimit } from "../../Config";
import { useNavigate } from "react-router-dom";
import { IoCopySharp } from "react-icons/io5";
import { capitalizeFirstLetter, getModeName, handleCopy, truncateText } from "../../helpers";
import { MdOutlineChevronRight } from "react-icons/md";
import { FaCheck } from "react-icons/fa";
import { GoDownload } from "react-icons/go";
import { IoMdMore } from "react-icons/io";

const RefundTable = ({
    apiData,
    setSelectedData,

}) => {
    const storageKey = `tenant_refund_page`;
    const [data, setData] = useState([]);
    const navigate = useNavigate();
    const [selectedRow, setSelectedRow] = useState(null);
    const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
    const [openActionMenu, setOpenActionMenu] = useState(null);
    const storageValue = sessionStorage.getItem(storageKey);
    const savedPage = storageValue !== null ? Number(storageValue) : 0;
    const [currentPage, setCurrentPage] = useState(savedPage);
    const toggleRow = (index) => {
        setSelectedRow(selectedRow === index ? null : index);
    };
    const [previousId, setPreviousId] = useState(null);
    useEffect(() => {
        setCurrentPage(savedPage);
    }, [savedPage]);


    useEffect(() => {
        if (apiData) {
            const tempData = apiData.map((item) => ({
                name: getName(item),
                amount: <Amount>{'₹' + Math.abs(item?.amount)}</Amount>,
                property: getPropName(item),
                mode: getPaymentModeX(getModeName(item.mode)),
                collectionDate: <span className='text-gray-600 text-sm'>{moment(item.collectionDate).format("DD, MMM YY")}</span>,
                action: ActionBtns(item),

            }));
            setData(tempData);
        }
    }, [apiData, openActionMenu]);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                !event.target.closest("#menuOptions") &&
                !event.target.closest(".action-btn")
            ) {
                setOpenActionMenu(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    const getName = (item) => {
        const e = item.isMovedOut ? "1" : "";
        const name = item?.tenantName ? capitalizeFirstLetter(item?.tenantName) : 'N/A';
        return (
            <UserImageWrapper
            >
                <UserImage src={Images.Avatar} alt={`Avatar for ${item?.tenantName}`} />
                <div className="flex flex-col gap-1">
                    <span className="text-gray-600 text-sm">
                        {truncateText(name, 25)}{""}
                        {/* <span className="text-xs bg-zinc-100 text-zinc-500 px-1 py-0.5 rounded-sm">
              {getTenantGender(item?.gender)}
            </span> */}
                    </span>
                    <span className="text-gray-400 text-xs">#{item?.tenantMobile}</span>
                </div>
            </UserImageWrapper>
        );
    };
    const getPropName = (item) => {
        return (
            <div className="flex flex-col">
                <span className="text-gray-600 text-sm">{item?.propName ? truncateText(item.propName, 20) : "-"}</span>
            </div>
        );
    };
    // const getAmount = (item) => {
    //     return (
    //         <div className="flex flex-col gap-1">
    //             <Amount>₹{Math.abs(item?.amount)}</Amount>
    //                   </div>
    //     )
    // };
    const getPaymentModeX = (mode) => {
        return (<div className="flex flex-col gap-0">
            <span className="text-gray-600 text-sm">
                {mode}{" "}
            </span>

        </div>);
    };
    const downloadReceipts = (receipt) => {
        window.open(receipt, "_blank");
    };
    const downloadSettlemet = (settlementSummary) => {
        window.open(settlementSummary, "_blank");
    };
    const ActionBtns = (item) => {
        return (
            <div className="flex gap-4">
                {item.settlementSummary &&
                    <button
                        title="Settlement Summary"
                        onClick={() => {
                            downloadSettlemet(item.settlementSummary)
                        }}
                        className={`cursor-pointer text-sm px-4 py-1 rounded-lg ${' text-gray-600'} flex items-center gap-1`}
                    >
                        {/* Edit */}
                        <GoDownload className="text-gray-300" size={24} />

                    </button>}
            </div>
        );
    };
    // const ActionBtns = (item) => {

    //     const openMenu = (id) => {
    //         setPreviousId(openActionMenu);
    //         setOpenActionMenu((prevId) => {
    //             return prevId === id ? null : id;
    //         });
    //     };

    //     return (
    //         <ActionBtnWrapper>
    //             {openActionMenu === item.id && (
    //                 <MenuOptions id="menuOptions">
    //                     {item.settlementSummary &&
    //                         <MenuItem
    //                             title="Get Settlement"
    //                             onClick={() => {
    //                                 downloadSettlemet(item.settlementSummary)
    //                             }}
    //                         >
    //                             <GoDownload className="text-gray-700 " /> Settlement Summary
    //                         </MenuItem>}
    //                     <MenuItem
    //                         title="Get Receipt"
    //                         onClick={() => {
    //                             downloadReceipts(item.receipt)
    //                         }}
    //                     >
    //                         <GoDownload className="text-gray-700 " /> Get Receipt
    //                     </MenuItem>

    //                 </MenuOptions>
    //             )
    //             }
    //             <Btn title="Actions" type="button" onClick={() => openMenu(item.id)}>
    //                 <IoMdMore className="text-gray-600" size={24} />
    //             </Btn>
    //         </ActionBtnWrapper >
    //     );
    // };


    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth < 768);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const columns = React.useMemo(() => {
        if (isMobileView) {

            return [
                {
                    Header: "Tenant",
                    accessor: "name",

                },
                {
                    Header: "Amount",
                    accessor: "amount",

                },
            ];
        }

        return [
            {
                Header: "Tenant",
                accessor: "name",

            },
            {
                Header: "Property",
                accessor: "property",

            },
            {
                Header: "Amount",
                accessor: "amount",

            },

            {
                Header: "Mode",
                accessor: "mode",

            },
            {
                Header: "Date",
                accessor: "collectionDate",

            },

            {
                Header: "",
                accessor: "action",

            },
        ];
    }, [isMobileView]);

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        pageOptions,
        page,
        state: { pageIndex, pageSize },
        previousPage,
        nextPage,
        setPageSize,
        canPreviousPage,
        canNextPage,
    } = useTable(
        {
            data,
            columns,
            initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
        },
        useSortBy,
        usePagination
    );

    useEffect(() => {
        sessionStorage.setItem(storageKey, pageIndex);
    }, [pageIndex, storageKey]);

    return (
        <>
            <CustomTable {...getTableProps()}>
                <Thead>
                    {headerGroups.map((headerGroup) => (
                        <Tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <Th
                                    {...column.getHeaderProps(column.getSortByToggleProps())}
                                // style={{ width: column.width }}
                                >
                                    {/* <div className="flex items-center"> */}
                                    {column.render("Header")}
                                    <span >
                                        {column.isSorted ? (
                                            <img
                                                src={Images.Arrow}
                                                alt="sort arrow"
                                                className={`${column.isSortedDesc ? "-rotate-90" : "rotate-90"
                                                    } w-1.5 inline-block ml-1.5`}
                                            />
                                        ) : (
                                            ""
                                        )}
                                    </span>
                                    {/* </div> */}
                                </Th>
                            ))}
                        </Tr>
                    ))}
                </Thead>
                <Tbody {...getTableBodyProps()} hasdata={(apiData?.length > 0).toString()}>
                    {page.map((row, rowIndex) => {
                        prepareRow(row);
                        const rowData = apiData?.[rowIndex];

                        return (
                            <React.Fragment key={rowIndex}>
                                <Tr
                                    {...row.getRowProps({ style: { height: "80px" } })}
                                    hasdata={(apiData?.length > 0).toString()}
                                >
                                    {row.cells.map((cell, cellIndex) => {
                                        return (
                                            <Td {...cell.getCellProps()}
                                                onClick={() => {
                                                    if (
                                                        cellIndex === 0 ||
                                                        (cellIndex === 1 && isMobileView)
                                                    ) {
                                                        toggleRow(rowIndex);
                                                    }
                                                }}
                                                style={{ maxWidth: "320px" }}>

                                                {cell.render("Cell")}
                                            </Td>)
                                    })}
                                </Tr>

                                {/* Mobile expanded view */}
                                {isMobileView && selectedRow === rowIndex && (
                                    <Tr >
                                        <Td colSpan={columns.length}>
                                            <ul className="flex flex-col gap-2">

                                                <li className="flex gap-2">
                                                    <strong>Mode:</strong> {data[rowIndex].mode}
                                                </li>
                                                <li className="flex gap-2">
                                                    <strong>Date:</strong> {data[rowIndex].collectionDate}
                                                </li>
                                                <li>
                                                    <strong>Action:</strong> {data[rowIndex].action}
                                                </li>
                                            </ul>

                                        </Td>
                                    </Tr>
                                )}
                            </React.Fragment>
                        );
                    })}
                </Tbody>
            </CustomTable>

            {data.length > 0 && (
                <PaginationWrapper>
                    <div className="px-2">
                        Page{" "}
                        <em>
                            {pageIndex + 1} of {pageOptions.length}
                        </em>
                    </div>

                    <div className="flex gap-1">
                        <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
                            <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75" />
                        </PrevBtn>
                        <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
                            <img
                                src={Images.Arrow}
                                alt="arrow"
                                className="w-2 rotate-180 opacity-75"
                            />
                        </NextBtn>
                    </div>
                </PaginationWrapper>
            )}

            {/* {data.length === 0 && !isMobileView && (
                <div className="text-center py-8 text-gray-500">
                    No valid agreements found
                </div>
            )} */}
        </>
    );
};

// Styled Components
const CustomTable = tw.table` w-full text-zinc-600`;
const Thead = tw.thead`border-b uppercase text-gray-600 bg-blue-50`;
const Tbody = tw.tbody`${(props) => (props.hasdata === "true" ? "border-b" : "")}`;
const Tr = tw.tr`${(props) =>
    props.hasdata === "true"
        ? "border-b"
        : ""} rounded-md overflow-hidden hover:bg-slate-50`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-normal text-gray-600`;
const Td = tw.td`p-3 text-sm md:p-3 text-left`;
const UserImageWrapper = tw.div` flex items-center gap-2 cursor-pointer`;
const UserImage = tw.img`w-10 h-10 rounded-full `;
const Amount = tw.p`text-gray-600 text-sm bg-neutral-100 px-3 py-1 rounded-md inline-flex`

export default RefundTable;